import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EventResponse } from '../../../constants';
import EventListView from '../../searchResult';
import { Creators as eventScrollActions } from '../../../../../../domain/useCases/events/getEventsUseCase/getEventsByStudentScroll';
import { useOrganizer } from '@/presentation/hooks/useOrganizer';

interface ConferenceProps {
  current: number;
  handleTab: (selected: number) => void;
  selectEvent: (eventId: number, typeEvent: string) => void;
  tabTitle: string;
}

const Conferences = (props: ConferenceProps) => {
  const { current, handleTab, selectEvent, tabTitle } = props;
  const dispatching = useDispatch();
  const { organizerList } = useOrganizer();
  const [paging, setPaging] = useState(1);
  const { data, showMore, isLoading } = useSelector(
    (state: any) => state?.getEventsByStudentScroll
  );

  const loadMoreEventsConferences = () => {
    setPaging((prevPage) => prevPage + 1);
  };

  const tabNumberToType = (tabNumber: number) =>
    Object.values(EventResponse)[tabNumber - 1];

  useEffect(() => {
    dispatching(
      eventScrollActions.getEventsByStudentScroll(
        tabNumberToType(current),
        paging
      )
    );
  }, [paging]);

  return (
    <EventListView
      options={organizerList}
      handleTab={handleTab}
      selectEvent={selectEvent}
      tabTitle={tabTitle}
      current={current}
      eventType="conferencias"
      loadMoreEvents={loadMoreEventsConferences}
      isLoading={isLoading}
      showMore={showMore}
      data={data}
    />
  );
};

export default Conferences;
